import { VFC } from "react";
import { Button, FormInstance, Input } from "antd";
import { GiRollingDices } from "react-icons/gi";

export const InventedNameInput: VFC<{
  form: FormInstance;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  value?: string;
}> = ({ form, onChange, value }) => {
  return (
    <Input.Group>
      <Input
        allowClear={true}
        value={value}
        onChange={onChange}
        style={{ width: "calc(100% - 100px)" }}
      />
      <Button
        onClick={() => {
          const index = Math.round(Math.random() * liste.length);
          form.setFieldsValue({ inventedName: liste[index] });
        }}
        type={"primary"}
        icon={<GiRollingDices />}
      >
        Zufällig
      </Button>
    </Input.Group>
  );
};

const liste = [
  "SpongeBob Schwammkopf",
  "Sailor Moon",
  "Ash (Pokémon)",
  "Bibi Blocksberg",
  "Popeye",
  "Pumuckl",
  "Barbie",
  "Biene Maja",
  "Elsa",
  "Arielle",
  "Nemo",
  "Jasmin (Aladin)",
  "Belle (Schöne und das Biest)",
  "Mulan",
  "Simba",
  "Rapunzel",
  "Schneewittchen",
  "Aschenputtel",
  "Dornröschen",
  "Rotkäppchen",
  "Frau Holle",
  "Rumpelstilzchen",
  "Angela Merkel",
  "Donald Trump",
  "Barack Obama",
  "Wladimir Putin",
  "Helmut Kohl",
  "Gerhard Schröder",
  "Arnold Schwarzenegger",
  "John F. Kennedy",
  "Harry Potter",
  "Gandalf",
  "Der Grinch",
  "Gollum",
  "Luke Skywalker",
  "Darth Vader",
  "Voldemort",
  "Hulk",
  "Heidi Klum",
  "Helene Fischer",
  "Tom Kaulitz",
  "Albert Einstein",
  "Albert Einstein",
  "Obelix",
  "Bugs Bunny",
  "Peter Pan",
  "Dumbledore",
  "Stewie (Family Guy)",
  "Ronald McDonald",
  "Weinachtsmann",
  "Super Mario",
  "Hugh Hefner",
  "Stitch (Lilo & Stitch)",
  "Polizeiauto",
  "Elon Musk",
  "Jeff Bezos",
  "Katzenklo",
  "Rudolf, das Rentier mit der roten Nase",
  "Kapitän Blaubär",
  "Mark Zuckerberg",
  "Pikachu",
  "Justin Bieber",
  "JK Rowling",
  "Garfield",
  "Elvis Presley",
  "Michel aus Lönneberga",
  "Brain (Pinky und der Brain)",
  "Bud Spencer",
  "Mario Götze",
  "Helmut Schmidt",
  "Opel",
  "Winnie Pooh",
  "Daniela Katzeberger",
  "Gwen Stefani",
  "J.R.R. Tolkien",
  "Link (Zelda)",
  "Usain Bolt",
  "Mr. Bean",
  "Miss Piggy",
  "Pumuckl",
  "Jack Sparrow",
  "Yoshi",
  "Die kleine Raupe Nimmersatt",
  "Pippi Langstrumpf",
  "Stephan Hawking",
  "Hermine Granger",
  "Sheldon Cooper",
  "Schlumpfine",
  "Leonardo da Vinci",
  "Elisabeth von Österreich-Ungarn (Sissi)",
  "R2D2 (Star Wars)",
  "Faust",
  "Indiana Jones",
  "Dori (Findet Nemo)",
  "Papst Benedikt",
  "David Hasselhoff",
  "Das Sandmännchen",
  "Wilhelm Tell",
  "Daniel Düsentrieb",
  "Columbo",
  "MacGyver",
  "Stephen King",
  "Che Guevara",
  "Peter Pan",
  "Wall-E",
  "Marry Poppins",
  "Oscar Schindler",
  "Blade Runner",
  "George Clooney",
  "Struwwelpeter",
  "Neil Armstrong",
  "Dumbo",
  "Frodo Beutlin (Herr der Ringe)",
  "Recep Erdogan",
  "Barbara Schöneberger",
  "Christopher Robin (Winnie Pooh)",
  "Micky Maus",
  "Sid (Ice Age)",
  "Gandalf",
  "Ampelmännchen",
  "Marie Curie",
  "Ikarus",
  "Kurt Cobain",
  "Die Hexe aus Hänsel und Gretel",
  "Goofy",
  "Jack the Ripper",
  "Sandra Bullock",
  "Alf",
  "Martin Luther King",
  "Konrad Adenauer",
  "Huckleberry Finn",
  "Jessica Fletcher",
  "Dr. Quinn",
];
